import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../services/api'
import './ResponsibleArea.css'
import { MainLayout } from '../../Layout/MainLayout'


export function CreateResponsibleArea() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState('')

    const [form, setForm] = useState({
        name: '',
        contactEmail: '',
    })

    function set(field: string, value: string) {
        setForm(prev => ({ ...prev, [field]: value }))
        setError('')
    }

    function validate() {
        if (!form.name.trim()) return 'Nome é obrigatório'
        return null
    }

    async function handleSubmit() {
        const err = validate()
        if (err) { setError(err); return }

        setLoading(true)
        setError('')
        try {
            await api.post('/responsible-area', {
                name: form.name,
                contactEmail: form.contactEmail || undefined,
            })
            setSuccess(true)
            setTimeout(() => navigate('/admin'), 1800)
        } catch (e: any) {
            setError(e.response?.data?.message || 'Erro ao criar Área')
        } finally {
            setLoading(false)
        }
    }

    if (success) return (
        <MainLayout>
            <div className="cu-success-wrap">
                <div className="cu-success-icon">✓</div>
                <h2 className="serif">Área criada!</h2>
                <p>Redirecionando para o painel...</p>
            </div>
        </MainLayout>
    )

    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="breadcrumb">
                    <a onClick={() => navigate('/admin')}>Admin</a>
                    <span className="sep">›</span>
                    <span>Nova área</span>
                </div>

                <div className="cu-layout">
                    <div className="cu-header">
                        <div className="kicker">Gestão</div>
                        <h1 className="serif">Novo área</h1>
                        <p>Crie uma nova área para cursos.</p>
                    </div>

                    <div className="cu-form-card">
                        {error && <div className="cu-error">{error}</div>}

                        <div className="cu-section-label">Dados</div>
                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>Nome *</label>
                                <input
                                    type="text"
                                    value={form.name}
                                    onChange={e => set('name', e.target.value)}
                                    placeholder="Nome da Area de Treinamento"
                                    autoFocus
                                />
                            </div>
                            <div className="field" style={{ flex: 1 }}>
                                <label>E-mail</label>
                                <input
                                    type="email"
                                    value={form.contactEmail}
                                    onChange={e => set('contactEmail', e.target.value)}
                                    placeholder="email@gazin.com.br"
                                />
                            </div>
                        </div>

                        <div className="cu-actions">
                            <button
                                className="btn btn-ghost"
                                onClick={() => navigate('/admin')}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Criando...' : 'Criar área →'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}